import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Col, Row, Button, Modal } from 'react-bootstrap';
import Card from '../../../components/Card/Card';
import ReactTable from 'react-table-6';
import 'react-table-6/react-table.css';
import _ from 'lodash';
import { rutas } from '../../../routes_backend/routes';
import Loading from '../../../views/Loading';
import UserDetails from './UserDetails';
import { dominio } from "../../../routes_backend/routes.jsx";


class administrationsUsers extends Component {
	constructor() {
		super();
		this.state = {
			isLoading: false,
			message: '',
			columns: [
				
				{ Header: 'Usuario SAP', accessor: 'USER_CODE' },
				{ Header: 'nombre', accessor: 'nombre' },
				{ Header: 'apellido', accessor: 'apellido' },
				{ Header: 'email', accessor: 'email' },
				{ Header: 'cargo', accessor: 'cargo' }
			],
			data: [],
			showDetails: false,
			showModal: false,
			details: [],
			data_search: [],
			showEnable: false,
			showModalEnable: false,
			is_available: '',
			nombre: '',
			apellido: '',
			codigo: ''
		};
	}
	componentWillMount() {
		this.data();
	}

	data = () => {
		this.setState({
			message: '',
			isLoading: true
		});
		const response = fetch(`${dominio}/getUsuariosAdmin`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
		
			});
		
			response
			.then(async (res) => {
				let data = await res.json();
				console.log(data);
				let temp_Data = [];
				data.forEach((element) => {
					let obj = {
						DocEntry: element.DocEntry,
						U_UserId: element.U_UserId,
						USER_CODE: element.USER_CODE,
						nombre: element.U_Nombre,
						apellido: element.U_Apellido,
						cargo: element.U_Cargo,
						email: element.U_email,
						is_available: element.U_is_available,
						Almacen: element.Almacen,
						Planta: element.Planta
					};
					temp_Data.push(obj);
				});
				this.setState({
					message: '',
					isLoading: false,
					data: temp_Data,
					data_search: data
				});
			})
			.catch((error) => {
				console.log(error);
				this.setState({
					isLoading: false,
					message: 'error in the server'
				});
			});
	};
	onChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value,
			showReport: false
		});
	};
	handleCloseDetails = () => {
		this.data();
		this.setState({ showModal: false, details: '' });
	};
	handleCloseEnable = () => {
		this.data();
		this.setState({ showModalEnable: false });
	};

	edit = (U_UserId) => {

		const { data_search } = this.state;
		let array = [];
		data_search.forEach((element) => {
			if (element.U_UserId === U_UserId) {
				array.push(element);
			}
		});
		this.setState({
			showDetails: true,
			showModal: true,
			details: array
		});
	};

	delete = (U_UserId) => {
		const { data_search } = this.state;
		var is_available = '';
		var nombre = '';
		var apellido = '';
		var codigo = '';
		data_search.forEach((element) => {
			if (element.U_UserId === U_UserId) {
				is_available = element.U_is_available;
				nombre = element.U_Nombre;
				apellido = element.U_Apellido;
				codigo = element.U_UserCode;
			}
		});
		this.setState({
			showEnable: true,
			showModalEnable: true,
			is_available: is_available,
			nombre: nombre,
			apellido: apellido,
			codigo: codigo
		});
	};
	UpdateStatusUser = (id, available) => {
		let status = !parseInt(available);
		let url = `${rutas.update_status_users}?id=${id}&status=${status}`;
		fetch(url)
			.then(async (res) => {
				let data = await res.json();
				this.setState({
					message: data,
					isLoading: false
				});
			})
			.catch((error) => {
				console.log(error);
			});
	};
	render() {
		const columns = [
			{ Header: 'User ID', accessor: 'U_UserId' },
			{ Header: 'Usuario SAP', accessor: 'USER_CODE' },
			{ Header: 'nombre', accessor: 'nombre' },
			{ Header: 'apellido', accessor: 'apellido' },
			{ Header: 'email', accessor: 'email' },
			{ Header: 'cargo', accessor: 'cargo' },
			{ Header: 'Planta', accessor: 'Planta' },
			{ Header: 'Almacen', accessor: 'Almacen' },
			{ Header: 'Estado', accessor: 'is_available', Cell: (props) => <div>{parseInt(props.row.is_available) === 0 ? 'Suspendido' : 'Disponible'}</div> },
			{ Header: '', accessor: '', Cell: (props) => ( <Button bsStyle="primary" bsSize="small" active onClick={() => this.edit(props.row.U_UserId)}> Editar </Button> ) },

			{ Header: '', accessor: '', Cell: (props) => ( <Button bsStyle={parseInt(props.row.is_available) === 0 ? 'warning' : 'danger'} bsSize="small" active 
				onClick={() => this.delete(props.row.U_UserId)} > {parseInt(props.row.is_available) === 0 ? 'Habilitar' : 'Deshabilitar'} </Button> )
			}
		];
		return (
			<div className="content" style={{ textAlign: 'center', alignItems: 'center' }}>
				<Grid fluid>
					<Row>
						<Col md={12}>
							<Card
								title="USUARIOS REGISTRADOS BI MACIZO"
								category=""
								ctTableFullWidth
								ctTableResponsive
								content={
									<div className="content">
										<div>
											<div className="row">
												{!_.isEmpty(this.state.data) ? (
													<div className="col-sm-12">
														<ReactTable
															data={this.state.data}
															columns={columns}
															defaultPageSize={this.state.data.length}
															filterable={true}
															defaultFilterMethod={(filter, row, column) => {
																const id = filter.pivotId || filter.id;
																if (typeof filter.value === 'object') {
																	return row[id] !== undefined
																		? filter.value.indexOf(row[id]) > -1
																		: true;
																} else {
																	return row[id] !== undefined
																		? String(row[id]).indexOf(filter.value) > -1
																		: true;
																}
															}}
														/>
													</div>
												) : (
													'No data'
												)}
											</div>
										</div>

										{this.state.isLoading === false ? (
											this.state.showDetails && (
												<Modal
													show={this.state.showModal}
													onHide={this.handleCloseDetails}
													bsSize="large"
												>
													<Modal.Header closeButton>
														<Modal.Title>Edit Users</Modal.Title>
													</Modal.Header>
													<Modal.Body>
														<UserDetails details={this.state.details} />
													</Modal.Body>
													<Modal.Footer>
														<div style={{ float: 'left' }}>
															<Button onClick={this.handleCloseDetails}>Close</Button>
														</div>
													</Modal.Footer>
												</Modal>
											)
										) : null}

										{this.state.isLoading === false ? (
											this.state.showEnable && (
												<Modal
													show={this.state.showModalEnable}
													onHide={this.handleCloseEnable}
													bsSize="small"
												>
													<Modal.Header closeButton />
													<Modal.Body>
														<div>
															<center>
																<strong>
																	{parseInt(this.state.is_available) === 1 ? (
																		`Esta seguro de deshabilitar este usuario ${this
																			.state.nombre}, ${this.state.apellido} `
																	) : (
																		`Esta seguro de habilitar este usuario ${this
																			.state.nombre}, ${this.state.apellido} `
																	)}
																</strong>
															</center>
														</div>
													</Modal.Body>
													<Modal.Footer>
														<div style={{ float: 'left' }}>
															<Button
																onClick={this.handleCloseEnable}
																active
																bsStyle="danger"
															>
																No, Cancelar!
															</Button>
														</div>
														<div>
															<Button
																onClick={() =>
																	this.UpdateStatusUser(
																		this.state.codigo,
																		this.state.is_available
																	)}
																active
																bsStyle="success"
															>
																Si, Estoy Seguro!
															</Button>
															<p style={style.errorMessage}>{this.state.message}</p>
														</div>
													</Modal.Footer>
												</Modal>
											)
										) : null}
									</div>
								}
							/>
						</Col>
					</Row>
				</Grid>
				{this.state.isLoading && <Loading />}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(administrationsUsers);
const style = {
	text: {
		textAlign: 'center'
	},
	ColorCell: {
		textAlign: 'center',
		backgroundColor: '#dddddd',
		border: '0px solid',
		color: '#000'
	},
	errorMessage: {
		fontWeight: 'bold',
		fontSize: '12px',
		height: '10px',
		color: 'red'
	}
};
